/* eslint-disable no-console */
// Disable console error blocking to allow error information to be logged in the console
import { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button } from '@salecycle/ui-component-library';

const ErrorElement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  height: 100vh;
  width: 100vw;
  z-index: 1;
`;

const CTAElement = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const HeaderElement = styled.div`
  font-size: 22px;
  font-weight: 700;
  margin-top: 15px;
  margin-bottom: 15px;
  z-index: 1;
`;

interface ErrorBannerProps {
  error: Error | unknown; // Error object from error boundary
  errorInfo: React.ErrorInfo | null; // React error info with componentStack
}

export function ErrorBanner(props: ErrorBannerProps) {
  const { t } = useTranslation('errorBanner');
  useEffect(() => {
    console.error('ErrorBanner caught error:', props.error);
    console.error('ErrorBanner component stack:', props.errorInfo);
  }, [props]);

  return (
    <>
      <img
        style={{
          width: '100vw',
          height: '100vh',
          objectFit: 'cover',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
        src="/images/sc-auth-background.svg"
        alt="SaleCycle Background"
      />
      <ErrorElement>
        <HeaderElement>{t('heading')}</HeaderElement>
        <CTAElement>
          <Button
            variation="primary"
            style={{ margin: 10 }}
            onClick={() => {
              window.location.reload();
            }}
          >
            {t('reloadButton.label')}
          </Button>
          <Button
            variation="primary"
            style={{ margin: 10 }}
            onClick={() => {
              window.location.href = '/';
            }}
          >
            {t('homepageButton.label')}
          </Button>
        </CTAElement>
      </ErrorElement>
    </>
  );
}
